import React from "react";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap";
import API from "../../helpers/endpointservice";
import axios from "axios";
import $ from "jquery";
import CommonIcon from "../../helpers/icons";
import WarningComponent from "../../helpers/modal";
import Toaster from "../../helpers/toaster";
import LoaderVisible from "../../helpers/loader";
import PaginationComponent from "../../helpers/Pagination";
import LoaderFailed from "../../helpers/loaderFailed";
import { logoutFunction } from "../../custom/logoutFunction";
// import Autocomplete from "react-autocomplete";
// import Select from "react-select/creatable";
// import { AutoComplete } from "primereact/autocomplete";
// import { Stack, Autocomplete, TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { Stack } from "@mui/material/Stack";
import { TextField } from "material-ui-core";
import swal from "sweetalert";
import moment from "moment";

const styles = {
    placeholder: (provided) => ({
        ...provided,
        whiteSpace: "noWrap",
        textOverflow: "ellipsis",
    })
}

class Skills extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: "asc",
            sortBy: "skillName",
            currentUser: "",
            isRequestFailed: false,
            isRequestLoader: false,
            pageNewCount: false,
            height: window.innerHeight,
            isMobile: false,
            isEmptyField: false,
            isRadioMobile: false,
            isSmallMobile: false,
            iswebMobile: false,
            skillInput: "",
            skillId: NaN,
            userID: 0,
            id: null,
            pageCount: 20,
            skillsList: [],
            skillData: {},
            selectedItem: [],
            currentPage: 1,
            perPage: 20,
            totalCount: 0,
            requestCount: 0,
            currentCategoryId: '',
            currentEdit: [],
            mappingList: [],
            skillList: [],
            mapping: false,
            done: false,
            isSearch: false,
            searchInput: "",
            addcategoryValue: {
                categoryName: "",
                isSubCategory: false,
                categoryId: 0,
                parentCategoryId: 0
            },
            editcategoryValue: {
                categoryName: "",
                isSubCategory: false,
                categoryId: 0,
                parentCategoryId: 0
            },
            categoryEmpty: [],
            currentEditcategory: '',
            editReferenceData: "",
            isSameData: false,
            skillInputSelect: [],
            isEditView: false,
            isView: false,
            auditLog: [],
            capabilityExceed: false,
        };
    }
    componentDidMount() {
        this.state.isRequestLoader = true;
        this.getSkillsList();
        this.getSkillMasterData();
        let user = localStorage.getItem("UserId");
        let value = localStorage.getItem("Role").split(",")[0];
        this.state.userID = user;
        this.state.currentUser = value;
        const intervals = setInterval(() => {
            this.resize();
        }, 10);
        $("body").removeClass("scrollhide");

    }

    fetchPaginationList = (pageNumber, pageSize) => {
        this.state.isRequestLoader = true;
        this.state.perPage = pageSize;
        this.state.currentPage = pageNumber;
        this.setState({})
        this.getSkillsList();
    };

    resize = () => {
        if (window.innerWidth < 850) {
            this.state.isMobile = true;
        } else {
            this.state.isMobile = false;
        }
        if (window.innerWidth < 750) {
            this.state.isSmallMobile = true;
        } else {
            this.state.isSmallMobile = false;
        }
        if (window.innerWidth < 490) {
            this.state.isRadioMobile = true;
        } else {
            this.state.isRadioMobile = false;
        }
        if (window.innerWidth < 400) {
            this.state.iswebMobile = true;
        } else {
            this.state.iswebMobile = false;
        }

        this.state.height = window.innerHeight;
        this.setState({});
    };

    getSkillMasterData = () => {
        let apiUrl = `${API.GET_SKILLS_TYPE}`;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((res) => {
                if (res.status === 200) {
                    res.data.map((item) => {
                        this.state.skillList = [...this.state.skillList, item.skillName]
                        this.state.skillInputSelect = [...this.state.skillInputSelect, item.skillName]
                    })
                    //   this.state.skillList = res.data;
                }
            })
    };

    getSkillsList = () => {
        let apiUrl = `${API.GET_SKILLS}?sortBy=${this.state.sortBy}&isSortAscending=${this.state.order == "asc" ? true : false}&pageNumber=${this.state.currentPage}&pageSize=${this.state.perPage}`;
        axios({
            method: "POST",
            url: apiUrl,
            data: this.state.searchInput ? { name: this.state.searchInput } : {}
        })
            .then((res) => {
                if (res.status === 200) {
                    this.state.skillsList = res.data.values;
                    this.state.isRequestLoader = false;
                    this.state.pageCount = res.data.totalCount;
                    this.state.isSearch = false;
                    this.setState({});
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                this.setState({
                    isRequestLoader: false,
                    isRequestLoaderFailed: true
                })
                console.log(error);
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    };

    checkingMap = () => {
        let url = `${API.POST_VALIDATE_SKILLS}`;
        this.setState({
            isRequestLoader: true
        })
        axios({
            method: "POST",
            url: url,
            data: this.state.selectedItem
        })
            .then((res) => {
                if (res.data?.length > 0 && res.data) {
                    this.setState({
                        mapping: true,
                        mappingList: res.data,
                        isRequestLoader: false
                    }, () => { this.openRemoveScreen() })
                }
                else {
                    this.setState({
                        mapping: false,
                        isRequestLoader: false
                    }, () => { this.openRemoveScreen() })
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                this.state.isRequestLoaderFailed = true;
                this.state.isRequestLoader = false;
                console.log(error);
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    }

    addUpdateSkillList = (name) => {
        let Url = `${API.GET_EXIST_SKILL}?type=${this.state.skillData.skillName}&id=${name == "Add" ? 0 : this.state.skillData.id}`;
        let apiUrl = `${API.PUT_UPDATE_SKILLS}?userId=${this.state.userID}`;
        axios({
            method: "GET",
            url: Url,
        })
            .then((res) => {
                if (res.data == false) {
                    axios({
                        method: "PUT",
                        url: apiUrl,
                        data: this.state.skillData,
                    })
                        .then((res) => {
                            if (res.status === 200) {
                                this.setState({
                                    skillInput: [],
                                    skillInputSelect: []
                                }, () => this.getSkillMasterData())

                                if (name == "Update") {
                                    this.state.isRequestLoader = false;
                                    toast.success("Skill edited successfully", {
                                        position: toast.POSITION.TOP_RIGHT,
                                        color: "#fff",
                                    });
                                    $("#editSkillScreen").removeClass('show');
                                    this.setState({
                                        isEditView: false
                                    })
                                }
                                else if (name == "Add") {
                                    this.state.isRequestLoader = false;
                                    toast.success("Skill added successfully", {
                                        position: toast.POSITION.TOP_RIGHT,
                                        color: "#fff",
                                    });
                                    $("#addSkillScreen").removeClass('show');
                                }
                                this.state.skillInput = "";
                                this.state.id = null;
                                this.state.selectedItem = [];
                                this.setState({});
                                $("body").removeClass("scrollhide")
                                if (name == "Add") {
                                    this.clearSearchList();
                                } else {
                                    this.getSkillsList();
                                }
                            }
                        })
                        .catch((error) => {
                            logoutFunction(error?.response?.status);
                            this.state.isRequestLoader = false;
                            // if (name == "Update") {
                            //     toast.error("Failed to update skill", {
                            //         position: toast.POSITION.TOP_RIGHT,
                            //         color: "#fff",
                            //     });
                            // }
                            // else if (name == "Add") {
                            //     toast.error("Failed to add skill", {
                            //         position: toast.POSITION.TOP_RIGHT,
                            //         color: "#fff",
                            //     });
                            // }
                            swal("Error!", "Something went wrong. Please try again.", "warning");
                            console.log(error);
                        });
                }
                else {
                    this.setState({ isRequestLoader: false, isRequestFailed: false });

                    toast.error(
                        "This Skill is already given. Please add another Skill.",
                        {
                            position: toast.POSITION.TOP_RIGHT,
                            color: "#fff",
                        }
                    );
                }
            })
    };

    openSkillsList = () => {
        this.state.selectedItem = [];
        this.state.skillList = this.state.skillInputSelect;
        this.state.capabilityExceed = false;
        this.state.skillInput = "";
        $("#combo-box-red").removeAttr("id").attr("id", "combo-box-demo");
        let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("addSkillScreen"));
        myOffcanvas.show();
        $("body").addClass("scrollhide")
        if ((this.state.skillsList).length > 0) {
            this.state.id = this.state.skillsList[(this.state.skillsList).length - 1].id + 1;
        }
        this.setState({});
    };

    openRemoveScreen = () => {
        let myOffcanvas = new window.bootstrap.Modal(
            document.getElementById("CancelCourseScreen")
        );
        myOffcanvas.show();
        $("body").addClass("scrollhide");
    };

    deleteSkillsList = () => {
        this.state.isRequestLoader = true;
        // /${this.state.selectedItem}
        let apiUrl = `${API.DELETE_SKILLS}?userId=${this.state.userID}`;
        axios({
            method: "DELETE",
            url: apiUrl,
            data: this.state.selectedItem,
        })
            .then((res) => {
                if (res.status === 200) {
                    $("body").removeClass("scrollhide");
                    toast.success("Skill removed successfully", {
                        position: toast.POSITION.TOP_RIGHT,
                        color: "#fff",
                    });
                    this.state.skillInput = "";
                    this.state.selectedItem = [];
                    this.setState({});
                    this.getSkillsList();
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                // toast.error("Failed to remove skill", {
                //     position: toast.POSITION.TOP_RIGHT,
                //     color: "#fff",
                // });
                this.setState({ isRequestLoader: false })
                swal("Error!", "Something went wrong. Please try again.", "warning");
                $("body").removeClass("scrollhide");
                console.log(error);
            });
    }

    handleCheckbox = (id) => {
        const { selectedItem } = this.state;
        if (selectedItem.length == 0) {
            selectedItem.push(id);
        } else {
            if (selectedItem && selectedItem.filter((i) => i == id).length == 1) {
                selectedItem.map((i, ind) => (i == id ? selectedItem.splice(ind, 1) : ""));
            } else {
                selectedItem.push(id);
            }
        }
        this.setState({});
    };

    handleCheckboxTop = () => {
        let data = [];
        if (
            this.state.selectedItem?.length !=
            this.state.skillsList?.length &&
            this.state.selectedItem?.length > 0 &&
            this.state.skillsList?.length > 0
        ) {
            this.state.skillsList?.map((r) =>
                data.push(r.id)
            );
        }
        if (
            this.state.selectedItem?.length == 0 &&
            this.state.skillsList?.length > 0
        ) {
            this.state.skillsList?.map((r) =>
                data.push(r.id)
            );
        }
        if (
            this.state.selectedItem?.length ==
            this.state.skillsList?.length &&
            this.state.skillsList?.length > 0
        ) {
            data = [];
        }
        this.state.selectedItem = data;
        this.setState({});
    };

    cancelDeletePopup = () => {
        $("body").removeClass("scrollhide")
    }

    addSkillsList = () => {
        if (this.state.skillInput?.trim() !== "") {
            this.state.skillData = {
                skillName: this.state.skillInput,
            }
            this.state.isEmptyField = false;
            this.state.isRequestLoader = true;
            this.setState({})
            this.addUpdateSkillList("Add");
            $("#combo-box-red").removeAttr("id").attr("id", "combo-box-demo");
        }
        else {
            $("#combo-box-demo").attr("id", "combo-box-red");
            this.setState({ isEmptyField: true })
        }

    }

    updateSkillsList = () => {
        if (this.state.skillInput?.trim() !== "") {
            // if(this.state.editReferenceData === this.state.skillInput.trim()){
            //     this.state.isSameData = true;
            //     this.setState({})
            // }
            // else{
            this.state.skillData = {
                id: this.state.selectedItem[0],
                skillName: this.state.skillInput,
            }
            this.state.isEmptyField = false;
            this.state.isSameData = false;
            this.state.isRequestLoader = true;
            this.setState({})
            this.addUpdateSkillList("Update");
            // }
        }
        else {
            this.setState({ isEmptyField: true, isSameData: false })
        }
    }

    clearSkillList = () => {
        this.state.skillInput = "";
        this.state.isEmptyField = false;
        this.state.selectedItem = [];
        this.state.skillData = {};
        this.state.data = [];
        this.state.order = "desc";
        this.state.isEditView = false;
        $("#addSkillScreen").removeClass("show");
        $(".offcanvas-backdrop").removeClass("show");
        $("body").removeClass("scrollhide")
        this.setState({})
    };

    getSkillValue = (isView, id) => {
        this.state.isRequestLoader = true;
        this.state.isView = isView;
        this.getSkillById(id || this.state.selectedItem[0])

        // this.setState({ isRequestLoader: true })
        // let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("editSkillScreen"));
        // myOffcanvas.show();
        // $("body").addClass("scrollhide")
    }

    getSkillById = (id) => {
        this.setState({ isEditView: true, capabilityExceed: false })
        $("#combo-box-red").removeAttr("id").attr("id", "combo-box-demo");
        let apiUrl = `${API.GET_SKILLS_BYID}?id=${id}`;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((res) => {
                if (res.status === 200) {
                    let auditLogTemp = res.data.historyLog;
                    this.state.skillInput = res.data.skillName;
                    this.state.editReferenceData = res.data.skillName;
                    this.state.auditLog = auditLogTemp; //res?.data?.historyLog || [];
                    this.state.isRequestLoader = false;
                    this.state.skillId = id;
                    this.state.selectedItem[0] = id;
                    this.setState({});
                    let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("editSkillScreen"));
                    myOffcanvas.show();
                    $("body").addClass("scrollhide")
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                console.log(error);
                this.setState({ isRequestLoader: false });
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    }

    sortTable = (name) => {
        let sortData = this.state.skillsList;
        if (sortData.length !== 0) {
            this.state.isRequestLoader = true;
            if (this.state.sortBy === name) {
                this.state.sortBy = name;
                if (this.state.order === "asc") {
                    var ordernew = "desc"
                    this.state.order = ordernew;
                }
                else {
                    var ordernew = "asc"
                    this.state.order = ordernew;
                }
            }
            else {
                this.state.sortBy = name;
                this.state.order = 'asc'
            }
            this.state.pageNewCount = !this.state.pageNewCount;
            this.setState({ currentPage: 1 }, () => {
                this.getSkillsList()
            })
            //   this.setState({currentPage : 1}, () => this.getSkillsList())
        }
    };


    openSearchFilterListView = () => {
        let myOffcanvas = new window.bootstrap.Offcanvas(
            document.getElementById("searchSkillScreen")
        );
        myOffcanvas.show();
        this.state.isSearch = true;
        this.state.isFieldEmpty = false;
        $("body").addClass("scrollhide");
    }

    searchSkillList = () => {
        if (this.state.searchInput?.trim() !== "") {
            this.state.isFieldEmpty = false;
            this.state.isRequestLoader = true;
            this.setState({})
            $("#searchSkillScreen").removeClass('show');
            $("body").removeClass("scrollhide")
            this.getSkillsList();
        }
        else {
            this.setState({ isFieldEmpty: true })
        }
    }

    clearSearchList = () => {
        this.setState({
            searchInput: "",
            isRequestLoader: true,
            isSearch: false
        }, () => this.getSkillsList())
        $("#searchSkillScreen").removeClass('show');
        $("body").removeClass("scrollhide")
    }

    handleSelectChange = (e, value) => {
        this.state.skillList = this.state.skillInputSelect.filter((item) => (item.toLowerCase().includes((value).toLowerCase())))
        this.setState({})
        if (value.length > 0) {
            if (value.trim().length > 250) {
                this.state.skillInput = "";
                this.setState({});
            } else {
                this.setState({ skillInput: value })
            }
        } else {
            this.setState({ skillInput: "" })
        }
        // this.state.skillList = ["guna"]
        // console.log(this.state.skillInputSelect.filter((item) => item.toLowerCase().includes((e.query).toLowerCase())))
        // this.state.skillList = this.state.skillInputSelect.filter((item) => (item.toLowerCase().includes((e.query).toLowerCase())))
        this.setState({})
    }

    //   onChangeSkill = (e) => {
    //     console.log(e)
    //   this.setState({skillInput : e, skillInputSelect : {value: `${e}`, label}})
    //   }

    handleInputChange = (name) => {
        if (name?.target?.value?.length > 0) {
            if (name?.target?.value?.trim().length > 250) {
                this.state.capabilityExceed = true;
                $("#combo-box-demo").attr("id", "combo-box-red");
                this.state.skillInput = "";
                this.setState({});
            }
            else {
                this.setState({ skillInput: name.target.value, capabilityExceed: false })
                this.state.skillList = this.state.skillInputSelect.filter((item) => (item.toLowerCase().includes((name?.target?.value).toLowerCase())))
                $("#combo-box-red").removeAttr("id").attr("id", "combo-box-demo");
                this.setState({})
            }
        } else {
            this.setState({ skillInput: name?.target?.value })
        }
    }

    //   renderSkillList = (state, val) => {
    //     return state?.skillName?.toLowerCase()?.indexOf(val?.toLowerCase()) !== -1;
    //   }
    handleUpdateskill = (e) => {
        if (e.target.value.length > 0) {
            if (e.target.value.trim().length > 250) {
                //this.state.skillInput = "";
                this.state.capabilityExceed = true;
                this.setState({});
                $("#combo-box-demo").attr("id", "combo-box-red");
            } else {
                this.setState({ skillInput: e.target.value, capabilityExceed: false })
                $("#combo-box-red").removeAttr("id").attr("id", "combo-box-demo");
            }
        } else {
            this.state.skillInput = e.target.value;
            $("#combo-box-red").removeAttr("id").attr("id", "combo-box-demo");
        }
    }

    render() {
        const {
            isMobile,
            isRequestFailed,
            isRequestLoader,
            isSmallMobile,
            pageCount,
            isRadioMobile,
            isEmptyField,
            selectedItem,
            sortBy,
            order,
            skillsList,
        } = this.state;
        let {
            menuToggle,
        } = this.props;
        return (
            <>
                <Toaster />
                {$("#addSkillScreen").hasClass("show") || $("#searchSkillScreen").hasClass("show") || $("#editSkillScreen").hasClass("show") ? <div className='viewbar-overlay'></div> : <></>}
                <div className={`${isMobile
                    ? "main-body-mobile" : menuToggle ? "menu-main-body" : "main-body"} `}>

                    <LoaderVisible isLoader={isRequestLoader} />
                    {/* <LoaderFailed isLoader={isRequestFailed} /> */}

                    <div className="head-fixed-company">
                        {isMobile == true ? (
                            <div className="mobile-head border-bottom w-100">
                                <div className="col-12 mobile-title">Skills</div>
                            </div>) : (
                            <div className="title">
                                <CommonIcon fileName="skillActiveIcon" /><span className="pl-10 head-span">Skills</span>
                            </div>)}
                        <div className={`${isMobile ? "" : ""} border-bottom`}>
                            <div className={`col-12 d-flex justify-content-start pl-10 ${isMobile ? "pr-0" : ""}`}>
                                <button className={`displaybutton ${isRadioMobile ? "pr-5" : ""} ${isSmallMobile ? "pl-5" : ""}`} onClick={() => this.openSkillsList()}>
                                    <CommonIcon fileName="addIcon" /><span className={`subhead-span p-2`}>Add</span>
                                </button>
                                {selectedItem?.length === 1 &&
                                    <button className={`displaybutton ${isRadioMobile ? "pr-5" : ""}  ${isSmallMobile ? "pl-5" : ""}`} onClick={() => this.getSkillValue(false, NaN)}>
                                        <CommonIcon fileName="EditIcon" /><span className={`subhead-span p-2`}>Edit</span>
                                    </button>}
                                {selectedItem?.length !== 0 &&
                                    <button className={`displaybutton ${isRadioMobile ? "pr-5" : ""}  ${isSmallMobile ? "pl-5" : ""}`}
                                        //  data-bs-toggle="modal" data-bs-target="#CancelCourseScreen"
                                        onClick={this.checkingMap}
                                    >
                                        <CommonIcon fileName="RemoveIcon" /><span className={`subhead-span p-2`}>Remove</span>
                                    </button>}
                                <div
                                    className={`position-absolute  end-0 ${isMobile ? "" : menuToggle ? "ml-role-updated" : "ml-role"
                                        }`}
                                >
                                    <button
                                        className="displaybutton"
                                        onClick={this.openSearchFilterListView}
                                    >
                                        <span>
                                            <CommonIcon fileName="filterIcon" />
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`${isMobile ? "favorite-mobile-table1" : "favorite-table1"} table-responsive w-100`}>
                        <div className={`table-fixed-header ${(isMobile ? "table-scroll-xy-mobile top-150px table-list-view-bottom" : menuToggle ? "table-scroll-xy-menutoggle top-upcoming-level table-list-view-bottom" : "table-scroll-xy  top-upcoming-level table-list-view-bottom")}`} >
                            <table className={`table  fileListTable2 table-borderless table-hover ${isMobile ? "" : ""} table-responsive`}>
                                <thead>
                                    <tr>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="request"
                                                checked={
                                                    selectedItem?.length > 0 &&
                                                        selectedItem?.length ==
                                                        skillsList?.length
                                                        ? true
                                                        : false
                                                }
                                                onClick={() => this.handleCheckboxTop()}
                                            />
                                        </td>
                                        <td className="cursor-pointer pl-20" onClick={() => this.sortTable("skillName")}>
                                            <span>Skills</span>
                                            {sortBy === "skillName" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                                        </td>
                                        <td></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {skillsList?.length !== 0 ? (skillsList?.map((item, index) => (
                                        <tr key={index} className="background-color-table">
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    name="request"
                                                    className="checkboxes t-input"
                                                    checked={
                                                        selectedItem?.filter(
                                                            (r) => r == item.id
                                                        )?.length > 0
                                                            ? true
                                                            : false
                                                    }
                                                    onClick={() => this.handleCheckbox(item.id)}
                                                />
                                            </td>
                                            <td className="pl-20 min-width-skill-masterdata">
                                                <span className="tablefilename cursor-pointer font-wei-600" onClick={() => this.getSkillValue(true, item.id)}>{item.skillName}</span>
                                            </td>
                                            <td></td>
                                        </tr>))) : (
                                        <tr> <td colSpan={8} className="table-nodata">{"No record found"}</td> </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>


                    {/* Add offcanvas */}
                    <div
                        className="offcanvas offcanvas-end offcanvasStyle"
                        tabIndex={-1}
                        data-bs-scroll="false"
                        data-bs-backdrop="false"
                        id="addSkillScreen"
                        aria-labelledby="offcanvasScrollingLabel">
                        <div
                            className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"
                                }`}>
                            <h6 id="offcanvasRightLabel" className="modal-title fw-600">
                                Add skill
                            </h6>
                            <button
                                className={`text-reset background-white offcavasclose buttonstyle ${isMobile ? "pr-0" : ""}`}
                                data-bs-dismiss="offcanvas"
                                onClick={() => this.clearSkillList()}
                            >
                                {/* <img src={CrossIcon} className="cursor-pointer app-image-hover" /> */}
                                <CommonIcon fileName="CrossIcon" className="cursor-pointer app-image-hover" />
                            </button>{" "}
                        </div>
                        <div className="offcanvas-body px-4 pt-0">
                            <div className="row">
                                {/* <div
                                    className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}
                                >
                                    <div className="form-group">
                                        <label
                                            className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                                            <CommonIcon className="properties-img-2" fileName="skillIcon" />{" "}
                                            <span className="pl-5 properties-search-span">
                                                Skill
                                            </span>
                                        </label>
                                        <input className={` form-control border-radius shiptype-select mt-2 font-size-12 `}
                                            onChange={(e) => {
                                                this.setState({ skillInput: e.target.value })
                                            }}
                                            style={{ borderColor: isEmptyField ? "#d12232" : "" }}
                                            value={this.state.skillInput}
                                        />
                                        {isEmptyField ? (
                                            <span className="send-rework-label">
                                                This field is required
                                            </span>
                                        ) : (
                                            <></>
                                        )}
                                    </div> */}
                                <div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}>
                                    <label
                                        className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                                        <CommonIcon className="properties-img-2" fileName="skillIcon" />{" "}
                                        <span className="pl-5 properties-search-span">
                                            Skill
                                        </span> <span className="MuiFormHelperText-contained">*</span>
                                    </label>
                                    <div className="react-autocomplete mt-3">
                                        {
                                            this.state.isEditView == false &&
                                            // <Autocomplete
                                            //     freeSolo
                                            //     id="combo-box-demo"
                                            //     options={this.state.skillList}
                                            //     sx={{ width: 300 }}
                                            //     value={this.state.skillInput}
                                            //     disableClearable={true}
                                            //     isOptionEqualToValue={(option, value) => option === value}
                                            //     // filterOptions={this.filterSkillList}
                                            //     onInputChange={(e) => this.handleInputChange(e)}
                                            //     onChange={(event, value) => this.handleSelectChange(event, value)}
                                            //     //onPaste={(e) => this.handleInputChange(e)}
                                            //     renderOption={(props, item) => (
                                            //         <div key={item} {...props}>{item}</div>
                                            //     )}
                                            //     noOptionsText={""}
                                            //     renderInput={(params) => <TextField {...params}
                                            //     />}
                                            // />

                                            <input
                                                onChange={(e) => this.handleInputChange(e)}
                                                //disabled={this.state.isView}
                                                className={` form-control border-radius mt-2 font-size-12 `}
                                                value={this.state.skillInput}
                                                style={{ borderColor: isEmptyField || this.state.capabilityExceed ? "#d12232" : "" }}
                                            />
                                        }
                                    </div>
                                    {/* <div className="autocomplete-wrappers">
                     <Autocomplete
                        contentEditable={true}
                        value={this.state.skillInput}
                        items={this.state.skillList ?? []}
                        getItemValue={(item) => item.skillName}
                        shouldItemRender={this.renderSkillList.bind(this)}
                        renderInput={(props) => {
                          return (<input 
                            id="exampleFormControlInput1"
                            className={`form-control equipment`} 
                            style={{ borderColor: isEmptyField ? "#d12232" : "" }}
                             required  {...props} />);
                        }}
                        renderMenu={(item) => (
                          <div key={item} className="dropdowns">{item}</div>)}
                        renderItem={(item, isHighlighted) => (
                          <div className={`items ${isHighlighted ? "selected-items" : ""}`} 
                       >
                        {item.skillName}
                       </div>
                       )}
                        onChange={(e) => this.handleInputChange(e)}
                        onSelect={(value) => this.handleSelectChange(value)}
                         /> 
                         </div> */}

                                    {/* <Select
                      className="text-12-normal-select"
                      classNamePrefix="assigngroups masterdata-assigngroups"
                      value={this.state.skillInputSelect}
                      options={this.state.skillList}
                    //   placeholder="Please select an option"
                      styles={styles}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) => this.handleInputChange(e)}
                      onInputChange={(e) => this.onChangeSkill(e)}
                    /> */}
                                    {/* <AutoComplete value={this.state.skillInput} options={this.state.skillList}  onChange={(e) => this.handleSelectChange(e)} className="p-invalid" /> */}
                                </div>
                                {isEmptyField ? (
                                    <span className="send-rework-label">
                                        This field is required
                                    </span>
                                ) : (
                                    <></>
                                )}
                                {this.state.capabilityExceed ? (
                                    <span className="spanErrMsg">
                                        Value must be less than 250 characters
                                    </span>
                                ) : (
                                    <></>
                                )}
                            </div>
                            {/* </div> */}
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
                                <button
                                    className={`btn btn-light input-group f-size-13 d-flex offcavasclose  ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"
                                        } p-2`}
                                    // data-bs-dismiss={this.state.isCategory1AddHide && "offcanvas"}
                                    aria-label="Close"
                                    onClick={() => this.addSkillsList()}
                                >
                                    {/* <img src={ButtonSubmitIcon} className="modal-img"></img> */}
                                    <CommonIcon fileName="ButtonSubmitIcon" className="modal-img" />
                                    <span className="model-label pl-10">Submit</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Edit offcanvas */}
                    <div
                        className={`offcanvas offcanvas-end offcanvasStyle ${this.state.isView ? "audit-offcanvas" : ''}`}
                        tabIndex={-1}
                        data-bs-scroll="false"
                        data-bs-backdrop="false"
                        id="editSkillScreen"
                        aria-labelledby="offcanvasScrollingLabel">
                        <div
                            className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"
                                }`}>
                            <h6 id="offcanvasRightLabel" className="modal-title fw-600">
                                {this.state.isView ? 'Skill' : 'Edit skill'}
                            </h6>
                            <button
                                className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : ""}`}
                                data-bs-dismiss="offcanvas"
                                onClick={() => this.clearSkillList()}
                            >
                                {/* <img src={CrossIcon} className="cursor-pointer app-image-hover" /> */}
                                <CommonIcon fileName="CrossIcon" className="cursor-pointer app-image-hover" />
                            </button>{" "}
                        </div>
                        <div className="offcanvas-body px-4 pt-0">
                            {
                                this.state.isView && <button className={`displaybutton ${isRadioMobile ? "pr-5" : "p-0"}  ${isSmallMobile ? "pl-5" : ""}`} onClick={() => this.getSkillValue(false, this.state.skillId)}>
                                    <CommonIcon fileName="EditIcon" /><span className={`subhead-span p-2`}>Edit</span>
                                </button>
                            }
                            <div className="row">
                                <div
                                    className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}
                                >
                                    <div className="form-group">
                                        <label
                                            className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                                            <CommonIcon className="properties-img-2" fileName="skillIcon" />{" "}
                                            <span className="pl-5 properties-search-span">
                                                Skill
                                            </span> <span className="MuiFormHelperText-contained">*</span>
                                        </label>
                                        <input
                                            onChange={(e) => this.handleUpdateskill(e)}
                                            disabled={this.state.isView}
                                            className={` form-control border-radius mt-2 font-size-12 `}
                                            value={this.state.skillInput}
                                            style={{ borderColor: isEmptyField || this.state.capabilityExceed ? "#d12232" : "" }}
                                        />
                                        {isEmptyField ? (
                                            <span className="send-rework-label">
                                                This field is required
                                            </span>
                                        ) : (
                                            <></>
                                        )}
                                        {this.state.capabilityExceed ? (
                                            <span className="spanErrMsg">
                                                Value must be less than 250 characters
                                            </span>
                                        ) : (
                                            <></>
                                        )}
                                        {/* {isSameData ? (
                                            <span className="send-rework-label">
                                                Changes required
                                            </span>
                                        ) : (
                                            <></>
                                        )} */}
                                    </div>{" "}
                                </div>
                            </div>

                            {
                                !this.state.isView && <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1"><button
                                    className={`btn btn-light input-group f-size-13 d-flex offcavasclose  ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"
                                        } p-2`}
                                    // data-bs-dismiss={this.state.isCategory1AddHide && "offcanvas"}
                                    aria-label="Close"
                                    onClick={() => this.updateSkillsList()}
                                >
                                    {/* <img src={ButtonSubmitIcon} className="modal-img"></img> */}
                                    <CommonIcon fileName="ButtonSubmitIcon" className="modal-img" />
                                    <span className="model-label pl-10">Update</span>
                                </button></div>
                            }
                            {
                                (this.state.isView || this.state.isEditView) && this.state.auditLog?.length > 0 && <div>
                                    <div className="pt-3">
                                        <h6 className="modal-title">Audit log</h6>
                                    </div>
                                    <div className="audit-table-wrapper audit-scroll-css">
                                        <table className="px-3 audit-table w-100">
                                            <thead>
                                                <tr className="border-bottom">
                                                    <th className="p-rem">
                                                        Action
                                                    </th>
                                                    <th className="p-rem">
                                                        Action By
                                                    </th>
                                                    <th className="p-rem wid-45">
                                                        Description
                                                    </th>
                                                    <th className="p-rem">
                                                        Date
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.auditLog?.map((x, i) => (
                                                        <tr className="border-bottom" key={i}>
                                                            <td className="p-rem" key={`${i}-action`}>{x.action ? x.action : "-"}</td>
                                                            <td className="p-rem" key={`${i}-actionby`}>{x.actionBy ? x.actionBy : "-"}</td>
                                                            <td className="p-rem" key={`${i}-desc`}>
                                                                {x.description ? x.description : "-"}
                                                            </td>
                                                            <td className="p-rem" key={`${i}-created`}>
                                                                {x.createdTime ? moment.utc(x.createdTime).local().format("DD-MMM-YYYY, hh:mm A") : "-"}
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                {/* Skill List View Search */}
                <div className="offcanvas offcanvas-end offcanvasStyle" tabIndex={-1} data-bs-scroll="false" data-bs-backdrop="false" id="searchSkillScreen" aria-labelledby="offcanvasScrollingLabel" >
                    <div className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}>
                        <h6 id="offcanvasRightLabel" className="modal-title fw-600">Search</h6>
                        <button className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : ""}`} data-bs-dismiss="offcanvas" onClick={() => { this.setState({ isSearch: false }) }}>
                            <CommonIcon fileName="CrossIcon" />
                        </button>
                    </div>
                    <div className="offcanvas-body px-4 pt-0">
                        <div className="row">
                            <div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}>
                                <div className="form-group">
                                    <label className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                                        <CommonIcon fileName="skillIcon" />
                                        <span className="pl-10 properties-search-span">Skill</span>
                                    </label>
                                    <input className={` form-control border-radius mt-2 font-size-12`}
                                        onChange={(e) => {
                                            this.setState({ searchInput: e.target.value })
                                        }}
                                        style={{ borderColor: this.state.isFieldEmpty ? "#d12232" : "" }}
                                        value={this.state.searchInput} />
                                    {this.state.isFieldEmpty ? (
                                        <span className="send-rework-label">This field is required</span>
                                    ) : (<></>)}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
                            {/* <button className={`btn btn-light input-group f-size-13 d-flex offcavasclose  ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"} p-2`} onClick={() => {this.state.isSearch ? this.searchLevel() : this.addLevelList()}}>
                  <CommonIcon fileName="ButtonSubmitIcon" /><span className="model-label pl-10" >{this.state.isSearch ? "Search" : "Submit"}</span>
                </button> */}
                            <button className="btn rejectbutton" onClick={() => this.clearSearchList()} >
                                <CommonIcon className="button-img" fileName="ButtonRejectApprovalIcon" />
                                <span className="px-1">Clear</span> </button>
                            <button
                                className={`btn approvebutton d-flex gap-1 mx-2`}
                                onClick={() => { this.searchSkillList() }}>
                                <span><CommonIcon fileName="searchableIcon" /></span>
                                <span className="model-label pl-vendor3 pl-2">Search</span>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Modal - Warning */}
                <WarningComponent
                    message={this.state.mapping ? (this.state.mappingList?.length > 1 ? "The following skills are tagged to courses/roles" : "The following skill is tagged to course/role") : (this.state.selectedItem?.length > 1 ? "Are you sure you want to remove these skills ?" : "Are you sure you want to remove this skill ?")}
                    isMobile={this.state.isMobile}
                    onYesClick={this.deleteSkillsList}
                    // warningMessage={this.clearWarningMesssage}
                    type={this.state.mapping ? (this.state.mappingList?.length > 1 ? "Skills" : "Skill") : ""}
                    mappingData={this.state.mapping ? this.state.mappingList : []}
                />

                {/* Pagination */}
                <PaginationComponent fetchPagination={this.fetchPaginationList} pageCount={pageCount}
                    activePageNumber={this.state.currentPage} reset={this.state.pageNewCount}
                />

            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return { dispatch };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Skills)
);
